import { render, staticRenderFns } from "./WppGroupsTable.vue?vue&type=template&id=0aa84cbb&scoped=true"
import script from "./WppGroupsTable.vue?vue&type=script&lang=js"
export * from "./WppGroupsTable.vue?vue&type=script&lang=js"
import style0 from "./WppGroupsTable.vue?vue&type=style&index=0&id=0aa84cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa84cbb",
  null
  
)

export default component.exports